import React, { useState } from "react";
import Lottie from "react-lottie";
import animationData from "../images/lottie/form1.json";
import { connect } from "react-redux";
import { login } from "../actions/auth";
import PropTypes from "prop-types";
import { Link, Redirect } from "react-router-dom";

const Login = ({ login, isAuthenticated, error }) => {
  const formAnimation = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const { email, password } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    login(email, password);
  };

  if (isAuthenticated) {
    return <Redirect to='/problems' />;
  }
  return (
    <>
      <div className='container-fluid problems'>
        <div className='row'>
          <div className='col-10 mx-auto'>
            <div className='row newdetails'>
              <div className='col-md-6' data-aos='zoom-in'>
                <img
                  src={require("../images/form.svg")}
                  alt='form'
                  className='img1 hide'
                />

                <div className='animate'>
                  <Lottie options={formAnimation} height={530} width={530} />
                </div>
              </div>
              <div className='col-md-6 px-5 mt-5 col-sm-12' data-aos='fade-up'>
                <h2>Login to LearnCode</h2>
                <form onSubmit={(e) => onSubmit(e)}>
                  <input
                    type='email'
                    name='email'
                    id='email'
                    placeholder='Email'
                    value={email}
                    onChange={(e) => onChange(e)}
                    required
                  />
                  <br />
                  <input
                    type='password'
                    name='password'
                    id='password'
                    placeholder='Password'
                    value={password}
                    onChange={(e) => onChange(e)}
                    required
                  />
                  <br />
                  <button type='submit' className='gbtn'>
                    Login
                  </button>
                  <br />
                  <button className='gbtn'>
                    <Link
                      to='/Register'
                      style={{ color: "inherit", textDecorationLine: "none" }}
                    >
                      Dont Have Account ? Register
                    </Link>
                  </button>
                  <br />
                  {error.msg === "Invalid Credentials" && (
                    <p className='my-2'>
                      <span style={{ color: "red" }}>{error.msg}</span>
                    </p>
                  )}
                  <br />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

Login.propTypes = {
  login: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  error: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  error: state.auth.error,
});

export default connect(mapStateToProps, { login })(Login);
